import { TranslationResources } from 'ff-shared-components-core';
import ExampleEnTranslations from '../common/resources.en.json';
import ExamplePtTranslations from '../common/resources.pt.json';

export const getResources = (): TranslationResources => {
	return {
		en: { translations: ExampleEnTranslations },
		pt: { translations: ExamplePtTranslations },
	};
};
